
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { TelemetryEntryListElement, TelemetryTileConfigInterface } from './telemetry.types';
import { Decoder } from '@/store-services/telemetry.mappings';
import TelemetryConfigDatapointComponent from './telemetry-config/telemetry-config-datapoint.vue';

@Component({
  components: {
    draggable,
    "telemetry-config-datapoint": TelemetryConfigDatapointComponent
  }
})
export default class TelemetryConfigComponent extends Vue {
  @Prop() config!: TelemetryTileConfigInterface;
  datapointAddingError: Array<string> = [];

  get enableHighlight() {
    if (!this.config.hasOwnProperty("highlight")) Vue.set(this.config, "highlight", true);
    return this.config.highlight;
  }

  set enableHighlight(value: boolean) {
    this.config.highlight = value;
  }

  get datapoints(): Array<TelemetryEntryListElement> {
    if (!this.config.hasOwnProperty("datapoints")) Vue.set(this.config, "datapoints", ["USLAB000084","USLAB000086","RUSSEG000001","TIME_000001","USLAB000039","USLAB000012","USLAB000011","USLAB000042","USLAB000041","USLAB000081","USLAB000013","USLAB000014","USLAB000015","USLAB000010","USLAB000005","USLAB000001","USLAB000002","USLAB000003","USLAB000004","S1000009","P1000007","USLAB000092","Z1000013","USLAB000095","USLAB000096","USLAB000097","USLAB000098","S0000007","S0000006","S0000008","S0000009","USLAB000025","USLAB000026","USLAB000027","AIRLOCK000054","USLAB000099","USLAB000100","USLAB000101","CSASSRMS003","CSASSRMS002","USLAB000058","AIRLOCK000049","AIRLOCK000054","S1000002","P1000002","S4000002","S4000001","S6000005","S6000004","P4000002","P4000001","P6000005","P6000004","S4000005","S4000004","S6000002","S6000001","P4000005","P4000004","P6000002","P6000001","CSASSRMS011"]);
    return this.config.datapoints.map((dp_i) => {return {id: dp_i, ...this.getMetadata(dp_i)}});
  }

  set datapoints(value: Array<TelemetryEntryListElement>) {
    this.config.datapoints = value.map(val => val.id);
  }

  getMetadata(id: string) {
    return Decoder.metadata(id);
  }

  get telemetryEntries() {
    let entries = Decoder.getTelemetryEntries();
    return entries
      .filter(e => !this.datapoints.find(d => d.id === e))
      .map((dp_i) => {
        let metadata = this.getMetadata(dp_i);
        return {value: dp_i, text: metadata.title}
      }).sort((a, b) => {
        let textA = a.text.toUpperCase();
        let textB = b.text.toUpperCase();
        if (textA < textB) {
          return -1;
        } else if (textA > textB) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  newEntry: string = "";
  addDatapoint(location?: number) {
    if (this.newEntry === "") {
      this.datapointAddingError = ["Please enter datapoint!"];
      return;
    }
    if (location) {
      let secondPart = this.config.datapoints.splice(location);
      this.config.datapoints.push(this.newEntry, ...secondPart);
    }
    else
      this.config.datapoints.push(this.newEntry);
    this.newEntry = "";
  }
  datapointHandler(id: string, event: {action: string, args?: any}) {
    switch(event.action) {
      case "add":
        this.addDatapoint(this.config.datapoints.indexOf(id) + 1);
        break;
      case "move":
        this.moveDatapoint(id, event.args);
        break;
      case "remove":
        this.removeDatapoint(id);
        break;
    }
  }
  moveDatapoint(id: string, beginning?: boolean) {
    this.config.datapoints.splice(this.config.datapoints.indexOf(id), 1);
    if (beginning) {
      this.config.datapoints.unshift(id);
    } else {
      this.config.datapoints.push(id);
    }
  }
  removeDatapoint(id: string) {
    this.config.datapoints.splice(this.config.datapoints.indexOf(id), 1);
  }
  clearDatapoints() {
    this.config.datapoints = new Array<string>();
  }

  @Watch('config')
  onConfigChange(value: TelemetryTileConfigInterface) {
    this.$emit('update:config', value);
  }
};

